import {
  alpaPerBlock as getAlpaPerBlock,
  consumerInfo as getConsumerInfo,
  supplierTotalAllocPoint,
} from '@/utils/web3';
import { userInfo as getUserInfo, rewardInfo as getRewardInfo, contractAddress } from '@/contract/wearableReward';
import BigNumber from 'bignumber.js';

export const wearableInfo = async (address: string) => {
  const blockPerWeek = !!process.env.VUE_APP_BSC ? 201600 : 40320;
  const allocPoint = !!process.env.VUE_APP_BSC ? 0.2 : 1;

  if (!address) {
    return;
  }

  const [
    userInfo,
    rewardInfo,
    alpaPerBlock,
    consumerInfo,
    totalAllocPoint,
  ] = await Promise.all([
    getUserInfo(address),
    getRewardInfo(),
    getAlpaPerBlock(),
    getConsumerInfo(contractAddress!),
    supplierTotalAllocPoint(),
  ]);

  let weeklyReward = new BigNumber(0);
  let percentage = new BigNumber(0);

  if (userInfo && rewardInfo && consumerInfo) {
    const share = new BigNumber(userInfo.wearableEnergy);
    const accShare = new BigNumber(rewardInfo.accShare);

    if (accShare.isGreaterThan(0)) {
      weeklyReward =
        share.dividedBy(accShare)
          // .multipliedBy(new BigNumber(alpaPerBlock))
          .multipliedBy(new BigNumber(allocPoint))
          .multipliedBy(blockPerWeek);
      percentage = share.dividedBy(accShare).multipliedBy(100);
    }
  }

  return {
    weeklyReward,
    percentage,
  };
};
